// localPhi.js - browser storage that holds patient data, and the sign-out sweep.
//
// Browser storage outlives the session: on a shared front-desk or exam-room
// workstation, whatever a signed-out user left in localStorage is readable by
// the next person at that machine, with no sign-in and no audit row. Only ids
// and UI preferences belong there. The few keys that do hold patient data
// (a clinical note draft kept so a crashed tab does not lose the note, a care
// manager's recent-member chips) are listed here and removed on every
// sign-out: explicit, idle and session-ended (see AuthProvider.jsx).
//
// scripts/check-local-storage-phi.mjs fails the build when a storage key is
// written that is not classified there, and when a key classified as patient
// data is not covered by a prefix below.

export const LOCAL_PHI_PREFIXES = [
  "pos_note_draft:",                      // ClinicalView: unsigned note autosave (full note text)
  "practiceos.cmConsole.recentMembers",   // usePinnedMember: recent member chips (id + display name)
  "pos.chwDraft.v1.",                     // chwFieldCore: CHW field-visit drafts (summary, escalation text, member label)
  // commandBarCore: recent charts per user (patient ids + when opened). No
  // names, but on a shared workstation it tells the next person which charts
  // the last user opened, so it goes with the session too.
  "practiceos.commandBar.recentPatients",
  // WaitlistUndoLink: waitlist bookings this user may still undo (offer and
  // visit ids + when). No names; it goes with the session all the same.
  "pos.waitlist.recentBooks",
];

// Remove every key under a LOCAL_PHI_PREFIXES prefix from localStorage and
// sessionStorage. Never throws: storage can be blocked (private mode).
export function clearLocalPhi() {
  for (const store of ["localStorage", "sessionStorage"]) {
    try {
      const s = typeof window !== "undefined" ? window[store] : null;
      if (!s) continue;
      const doomed = [];
      for (let i = 0; i < s.length; i++) {
        const k = s.key(i);
        if (k && LOCAL_PHI_PREFIXES.some((p) => k.startsWith(p))) doomed.push(k);
      }
      for (const k of doomed) s.removeItem(k);
    } catch (e) { /* storage blocked: nothing was written either */ }
  }
}
